var map = {
	"./Badschrank_1.jpg": 8337,
	"./Badschrank_1_lowres.jpg": 5302,
	"./Badschrank_2.jpg": 1697,
	"./Badschrank_2_lowres.jpg": 6438,
	"./Badschrank_3.jpg": 9023,
	"./Badschrank_3_lowres.jpg": 721,
	"./Bene_about.jpg": 8013,
	"./Bene_about_lowres.jpg": 9596,
	"./Bett_1.jpg": 4425,
	"./Bett_1_lowres.jpg": 1500,
	"./Bett_2.jpg": 478,
	"./Bett_2_lowres.jpg": 5643,
	"./Buffet_1.jpg": 8392,
	"./Buffet_1_lowres.jpg": 7380,
	"./Buffet_2.jpg": 95,
	"./Buffet_2_lowres.jpg": 4274,
	"./Couchtisch_1.jpg": 3538,
	"./Couchtisch_1_lowres.jpg": 3397,
	"./Couchtisch_2.jpg": 5764,
	"./Couchtisch_2_lowres.jpg": 1388,
	"./Gruppe_about.jpg": 2462,
	"./Gruppe_about_lowres.jpg": 2586,
	"./Johannes_about.jpg": 142,
	"./Johannes_about_lowres.jpg": 8339,
	"./Laura_about.jpg": 9974,
	"./Laura_about_lowres.jpg": 8065,
	"./Mathias_about.jpg": 2543,
	"./Mathias_about_lowres.jpg": 8528,
	"./Matthias_1.jpg": 623,
	"./Matthias_1_lowres.jpg": 7225,
	"./Matthias_2.jpg": 3698,
	"./Matthias_2_lowres.jpg": 7276,
	"./Matthias_3.jpg": 3932,
	"./Matthias_3_lowres.jpg": 76,
	"./Matthias_about.jpg": 2402,
	"./Matthias_about_lowres.jpg": 4068,
	"./Meister_1.jpg": 1499,
	"./Meister_1_lowres.jpg": 5913,
	"./Meister_2.jpg": 7553,
	"./Meister_2_lowres.jpg": 4288,
	"./Mika.jpg": 2212,
	"./Mika_about.jpg": 935,
	"./Mika_about_lowres.jpg": 7987,
	"./Nachttisch_1.jpg": 9916,
	"./Nachttisch_1_lowres.jpg": 9379,
	"./Nachttisch_2.jpg": 5406,
	"./Nachttisch_2_lowres.jpg": 6918,
	"./Sideboard_1.jpg": 6336,
	"./Sideboard_1_lowres.jpg": 697,
	"./Sideboard_2.jpg": 5987,
	"./Sideboard_2_lowres.jpg": 2420,
	"./Sideboard_3.jpg": 1930,
	"./Sideboard_3_lowres.jpg": 9802,
	"./Tisch_1.jpg": 7366,
	"./Tisch_1_lowres.jpg": 5646,
	"./Tisch_2.jpg": 6519,
	"./Tisch_2_lowres.jpg": 4837,
	"./Tisch_3.jpg": 5333,
	"./Tisch_3_lowres.jpg": 7316,
	"./Tisch_4.jpg": 7413,
	"./Tisch_4_lowres.jpg": 5192,
	"./Tisch_5.jpg": 8109,
	"./Tisch_5_lowres.jpg": 9213,
	"./Tisch_6.jpg": 1424,
	"./Tisch_6_lowres.jpg": 189,
	"./home_both.jpg": 7629,
	"./home_both_lowres.jpg": 6631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;